import React from 'react';

import { flagStyles } from '../settings';

const SvgGY = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2208px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGY;
